<ng-container [formGroup]="formGroupBuilder">
  <mat-form-field class="full-width" [class.loading]="dataLoading">
    <mat-label *ngIf="!multiple">{{titleField}}</mat-label>
    <mat-select [formControlName]="controlName" [disabled]="dataLoading || disabled" [required]="required"
      [multiple]="multiple" (selectionChange)="onSelectionChange($event)" (openedChange)="onOpenedChange($event)"
      [placeholder]='multiple ? titleField : ""'>
      <mat-select-trigger *ngIf="multiple" class="text_muted_grey">
        {{titleField}}
      </mat-select-trigger>
      <mat-select-trigger *ngIf="!multiple && hasImage && formGroupBuilder.get(controlName).value">
        {{ getSelectedTitle() }}
      </mat-select-trigger>
      <div class="mat_select_has_search">
        <div class="select-search-container">
          <div class="select-search-header" (keydown)="$event.stopPropagation()">
            <span class="search-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="15.997" viewBox="0 0 16 15.997">
                <path id="search"
                  d="M17.754,16.627l-2.966-2.944A7.194,7.194,0,1,0,13.677,14.8l2.942,2.944a.795.795,0,0,0,1.135-1.112ZM9.192,14.8a5.6,5.6,0,1,1,5.6-5.6,5.6,5.6,0,0,1-5.6,5.6Z"
                  transform="translate(-1.979 -1.979)" fill="#8e8fa2" />
              </svg>
            </span>
            <input #searchInput type="text" [formControl]="searchControl" [placeholder]="searchTitle"
              class="search-input" (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()" />
            @if (searchControl.value) {
            <button class="clear-icon" type="button" (click)="clearSearch($event)">
              <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px"
                fill="#8E8FA2">
                <path
                  d="m256-200-56-56 224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z" />
              </svg>
            </button>
            }
          </div>
        </div>
        <div class="select-all-checkbox" *ngIf="filteredData.length && selectAll">
          <mat-checkbox [checked]="isAllSelected()" [indeterminate]="isIndeterminate()"
            (change)="toggleSelectAll($event.checked)">
            {{"general.selectAll" | translate}}
          </mat-checkbox>
        </div>
        @if (filteredData.length === 0) {
        <div class="no-results">
          {{ 'general.noSearchResultsFound' | translate }}
        </div>
        } @else {
        @for (item of recordsData; track valueKey?item[key]:item) {
        <mat-option [value]="valueKey?item[key]:item" [hidden]="!isItemFiltered(item)"
          [disabled]="isOptionDisabled(item)">
          <div class="option-container">
            <ng-container *ngIf="hasImage">
              <img *ngIf="item.userImage" [src]="item.userImage" (error)='item.userImage = "assets/images/no_logo.png"'
                class="reviewer-img-thumb">
              <span *ngIf="!item.userImage">
                {{ item[titleKey]| shortName }}
              </span>
            </ng-container>
            <h6 class="title_option" [matTooltip]="item[titleKey]">{{ item[titleKey]}}</h6>
          </div>
        </mat-option>
        }
        }
      </div>
    </mat-select>

    <mat-error *ngIf="hasError(controlName, 'required')">
      {{errorMessage}}
    </mat-error>
  </mat-form-field>

  @if (multiple && selectedItems.length) {
  <mat-chip-set>

    @for (item of selectedItems; track valueKey?item[key]:item; let i = $index) {

    <mat-chip (click)="$event.stopPropagation()" (removed)="removeItem(i)" class="custom_mat_chip">
      <ng-container *ngIf="hasImage">
        <img *ngIf="item.userImage" [src]="item.userImage" alt="{{ item[titleKey] }}" class="reviewer-chip-img"
          (error)='item.userImage = ""' />
        <span *ngIf="!item.userImage" class="short_name">
          {{ item[titleKey] | shortName }}
        </span>
      </ng-container>
      {{ item[titleKey] }}
      <mat-icon matChipRemove (click)="$event.stopPropagation()" *ngIf="!disabled">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="15" viewBox="0 0 16 15">
          <path id="times-hexagon"
            d="M15.5,6.782,13.173,2.691A3.32,3.32,0,0,0,10.3,1H5.6A3.322,3.322,0,0,0,2.731,2.691L.4,6.782a3.493,3.493,0,0,0,0,3.436l2.327,4.091A3.32,3.32,0,0,0,5.6,16h4.7a3.322,3.322,0,0,0,2.871-1.691L15.5,10.218a3.493,3.493,0,0,0,0-3.436ZM14.351,9.531l-2.326,4.091A1.993,1.993,0,0,1,10.3,14.636H5.6a1.992,1.992,0,0,1-1.722-1.015L1.552,9.531a2.094,2.094,0,0,1,0-2.061L3.878,3.378A1.993,1.993,0,0,1,5.6,2.364h4.7a1.992,1.992,0,0,1,1.722,1.015l2.327,4.091A2.094,2.094,0,0,1,14.351,9.531ZM10.425,6.936,8.9,8.5l1.524,1.563a.694.694,0,0,1,0,.964.653.653,0,0,1-.94,0L7.961,9.464,6.437,11.027a.653.653,0,0,1-.94,0,.694.694,0,0,1,0-.964L7.021,8.5,5.5,6.936a.694.694,0,0,1,0-.964.652.652,0,0,1,.94,0L7.961,7.536,9.485,5.972a.652.652,0,0,1,.94,0A.694.694,0,0,1,10.425,6.936Z"
            transform="translate(0.049 -1)" fill="#6b6d85" />
        </svg>
      </mat-icon>
    </mat-chip>

    }

  </mat-chip-set>

  }
</ng-container>